import HundredBricksAPIError from '../../../HundredBricksAPIError';
class DiversificationScoreError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('DiversificationScoreError', ...args);
    }
}
export default DiversificationScoreError;
